import { configureStore } from '@reduxjs/toolkit';
import GruposReducer from '../Slice/GruposSlice';
import UserReducer from '../Slice/UserSlice';
import InvitationReducer from '../Slice/InvitationSlice';
import MiembrosReducer from '../Slice/MiembrosSlice';
import LicenciasReducer from '../Slice/LicenceSlice';

export const store = configureStore({
  reducer: {
    StoreGrupos: GruposReducer,
    StoreUsuarios: UserReducer,
    StoreInvitaciones: InvitationReducer,
    StoreMiembros : MiembrosReducer,
    StoreLicencias: LicenciasReducer
  },
});
